import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const getRadios = async () => {
  const response = await axios.get(`${getAPIService}/radios`)
  return response.data
}
